import React, { useCallback, ComponentProps } from 'react';
import { PaymentSource } from '../../constants';
import { useCart } from '../../hooks/useCart';
import { tc } from '../../lib/trackingContext';
import { PayPalButton } from '../PaymentSourceButton';
import { useChangePaymentSource } from './useChangePaymentSource';

type Props = Omit<ComponentProps<typeof PayPalButton>, 'paypalClientToken' | 'onSelect'>;

export const CheckoutPayPalButton: React.FC<Props> = props => {
  const {
    cart: {
      attributes: { paypalClientToken }
    }
  } = useCart();

  const changePaymentSource = useChangePaymentSource();

  const trackThirdParty = useCallback(() => {
    tc.track('Third Party Payment Method Flow Selected', {
      addToTrackingEvent: {
        payment_type: 'PAYPAL',
        label: 'PAYPAL'
      }
    });
  }, []);

  const onSelect = useCallback(
    () => changePaymentSource(PaymentSource.PayPal).then(() => trackThirdParty()),
    [changePaymentSource, trackThirdParty]
  );

  return <PayPalButton {...props} paypalClientToken={paypalClientToken} onSelect={onSelect} />;
};
